import { useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import { ArticlePageFragment } from '@contentsite/src/graphql/generated/graphql-types'

const getCommonProperties = (
  page: ArticlePageFragment,
  cultureCode: string
) => {
  const name = page.header;
  const headline = page.header
  const dateModified = page.updatedDateIso8601Text
  const datePublished = page.postDateIso8601Text
  const author = "Dustin"
  const mainImageUrl = page.mainImage?.url
  const fullMainImageUrl =
    mainImageUrl && (mainImageUrl?.includes('http') ? mainImageUrl : `https:${mainImageUrl}`)
  
  
  const image = getImageObject(fullMainImageUrl)  
  const logo = {
    '@type': 'ImageObject',
    url: "https://dustinweb.azureedge.net/content/77306/dustin-logo-black.png"
  }

  const publisher = {
    '@type': 'Organization',
    logo: logo,
    name : "Dustin"
  }
  const inLanguage = cultureCode
  
  const commonProperties = {
    name,
    headline,
    dateModified,
    datePublished,
    image,
    author,
    publisher,
    inLanguage
  }

  return commonProperties
}

const getImageObject = (imageUrl?: string) => {
  if (!imageUrl) {
    return
  }

  return {
    '@type': 'ImageObject',
    url: imageUrl,
  }
}

type ArticleProps = {
  page: ArticlePageFragment
}

export const ArticlePageSchema = ({ page }: ArticleProps) => {
  const { cultureCode } = useUserSettings()
  const commonProperties = getCommonProperties(page, cultureCode)
  const data = { ...commonProperties }

  return (
    <div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            ...data,
          }),
        }}
      />
    </div>
  )
}

type GuideProps = {
  page: ArticlePageFragment
}

export const GuidePageSchema = ({ page }: GuideProps) => {
  const { cultureCode } = useUserSettings()
  const commonProperties = getCommonProperties(page, cultureCode)
  const data = { ...commonProperties }

  return (
    <div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Guide',
            ...data,
          }),
        }}
      />
    </div>
  )
}
